import totalCampaigns from "../../../assets/icons/SidebarCampaignsIcon.svg";
import activeCampaigns from "../../../assets/icons/ActiveCampaignIcon.png";
import scheduledCampaigns from "../../../assets/icons/ScheduledCampaigns.png";

const CampaignStatCard = () => {
  const cardData = [
    {
      title: "Total Campaigns",
      value: 500,
      icon: totalCampaigns,
      bgColor: "#D2EBFF",
    },
    {
      title: "Active Campaigns",
      value: 200,
      icon: activeCampaigns,
      bgColor: "#C2FFC9",
    },
    // {
    // //   title: "Draft Campaigns",
    // //   value: 120,
    // //   icon: totalCampaigns,
    // //   bgColor: "#C9C9C9",
    // // },
    // // {
    // //   title: "Scheduled Campaigns",
    // //   value: 50,
    // //   icon: scheduledCampaigns,
    // //   bgColor: "#FFF1D2",
    // // },
    // // {
    // //   title: "Closed Campaigns",
    // //   value: 50,
    // //   icon: totalCampaigns,
    // //   bgColor: "#FFECBF",
    // },
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3">
      {cardData.map((card, idx) => (
        <div key={idx} className="flex">
          <div
            className="
              w-full h-full
              min-h-[110px]
              p-3
              rounded-xl
              shadow
              bg-white dark:bg-slate-800
              border border-transparent dark:border-slate-700
            "
          >
            <div className="flex items-center justify-between h-full px-3">
              {/* LEFT TEXT */}
              <div className="text-left">
                <h6 className="mb-1 text-base font-medium text-slate-700 dark:text-slate-300">
                  {card.title}
                </h6>
                <h3 className="text-[32px] font-bold leading-none text-slate-900 dark:text-white">
                  {card.value}
                </h3>
              </div>

              {/* RIGHT ICON */}
              <div
                className="flex items-center justify-center rounded-full w-[55px] h-[55px] shrink-0"
                style={{ backgroundColor: card.bgColor }}
              >
                <img
                  src={card.icon}
                  alt={card.title}
                  className="w-1/2 h-1/2 object-contain"
                />
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default CampaignStatCard;